import React from 'react';

import observe from 'lib/intersection-observer/observe';

export interface Props {
    children?: React.ReactElement<any> | null;
    fetch?: (all: boolean) => Promise<any>;
    disabled?: boolean;
}

interface State {
    visible: boolean;
}

class InfiniteScroll extends React.PureComponent<Props, State> {
    ref: React.RefObject<HTMLDivElement> = React.createRef();
    state: State = { visible: false };
    unobserve?: () => void;

    intersectionObserver?: IntersectionObserver;
    element?: Element | Text | null;

    componentDidMount() {
        const element = this.ref && (this.ref.current as Element | null);
        if (element) {
            this.unobserve = observe(
                element,
                () => {
                    if (!this.props.disabled) {
                        this.setState({ visible: true });
                    }
                },
                { rootMargin: '300px' }
            );
        }
    }

    componentWillUnmount() {
        if (this.unobserve) {
            this.unobserve();
            delete this.unobserve;
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const element = this.ref && (this.ref.current as Element | null);

        if (element && !this.unobserve) {
            this.unobserve = observe(
                element,
                () => {
                    if (!this.props.disabled) {
                        this.setState({ visible: true });
                    }
                },
                { rootMargin: '300px' }
            );
        }

        const appeared = this.state.visible && !prevState.visible;
        if (!this.props.disabled && appeared && this.props.fetch) {
            this.props.fetch(false).then(() => {
                this.setState({ visible: false });
            });
        }
    }

    render() {
        if (this.props.children) {
            return <div ref={this.ref}>{this.props.children}</div>;
        }

        return null;
    }
}

export default InfiniteScroll;
